module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/icon//icon-rank.png?v=0ff5cac0";